import React from 'react';
import { I18n } from 'react-redux-i18n';
import { NewTable } from '@common/components/new-table';
import { MODULE_NAME } from '@modules/invite-status/constants/shared';
import { Search } from '@common/components/Search';
import { PedigreeChooserProps, usePedigreeChooserController } from './pedigree-chooser.controller';

import './pedigree-chooser.styles.scss';

export const PedigreeChooser: React.FC<PedigreeChooserProps> = (props) => { 
  const { selectedPedigree } = props;

  const {
    searchKeyword,
    columnActions,
    headerActions,
    filters,
    handleSearch,
    handleSelectedPedigreesChange,
    handleColumnsOrderChange,
    handleColumnsResizing,
    changingColumns,
    getPedigreesProcessed,
    pedigreesLoadMetadata,
    pedigreesCount,
    pedigreesLoading,
    pedigrees,
    itemUniqProperty,
    tableColumns,
    getId,
    handleColumnAdd,
    handleColumnRemove,
    getFoldersForAddingColumns,
    handleGetFields,
  } = usePedigreeChooserController(props);

  return (
    <div className="InviteStatusPedigreeChooser">
      <h6 className="InviteStatusPedigreeChooser__title">{I18n.t('nameOfExistingPedigree')}</h6>
      <Search withLiveSearch value={searchKeyword} id="bw-quest-invites-step4-sel-ind-search-search-box" onSearch={handleSearch} />
      <NewTable
        infiniteScroll
        disableAutoInit
        classes={{
          root: 'InviteStatusPedigreeChooser__table'
        }}
        data={pedigrees}
        getId={getId}
        itemUniqProperty={itemUniqProperty}
        moduleName={`${MODULE_NAME}_patient_invite_pedigree_chooser`}
        columns={tableColumns}
        loading={{
          list: pedigreesLoading,
          columns: changingColumns,
        }}
        noDataMessage={I18n.t("There no pedigrees to display")}
        errorMessage={{ list: I18n.t('Failed to load pedigrees') }}
        selection={{
          type: 'single',
          items: selectedPedigree ? [selectedPedigree] : [],
          onChange: handleSelectedPedigreesChange,
        }}
        columnsResizing={{
          onChange: handleColumnsResizing,
        }}
        columnsOrder={{
          onChange: handleColumnsOrderChange,
        }}
        columnsManagement={{
          onAdd: handleColumnAdd,
          onRemove: handleColumnRemove,
          getFolders: getFoldersForAddingColumns,
          getFields: handleGetFields,
        }}
        headerActions={headerActions}
        columnActions={columnActions}
        filters={filters ? { operators: filters } : undefined}
        totalItemsCount={pedigreesCount}
        loadMetadata={pedigreesLoadMetadata}
        onLoadData={getPedigreesProcessed}
      />
    </div>
  );
};